"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Espilon Range Slider Module
 */
var EpsilonRangeSlider = /** @class */ (function () {
    /**
     * Class constructor
     * @param {{container: JQuery; params: {value: number; id: string; sliderControls: {min: number; max: number; step: number}}}} control
     */
    function EpsilonRangeSlider(control) {
        /**
         * Minimum
         * @type {number}
         */
        this.min = 1;
        /**
         * Maximum
         * @type {number}
         */
        this.max = 20;
        /**
         * Step incrementor
         * @type {number}
         */
        this.step = 1;
        this.context = jQuery(control.container).hasClass('slider-container') ? jQuery(control.container) : jQuery(control.container).find('.slider-container');
        this.min = control.params.sliderControls.min;
        this.max = control.params.sliderControls.max;
        this.step = control.params.sliderControls.step;
        this.value = control.params.value;
        if (!this.context) {
            return;
        }
        this.init();
    }
    /**
     * Initiator
     */
    EpsilonRangeSlider.prototype.init = function () {
        var self = this;
        var slider = this.context.find('.ss-slider'), input = this.context.find('.rl-slider'), inputId = input.attr('id'), id = slider.attr('id');
        jQuery('#' + id).slider({
            value: this.value,
            range: 'min',
            min: this.min,
            max: this.max,
            step: this.step,
            /**
             * Removed Change event because server was flooded with requests from
             * javascript, sending changesets on each increment.
             *
             * @param event
             * @param ui
             */
            slide: function (event, ui) {
                jQuery('#' + inputId).attr('value', ui.value);
            },
            /**
             * Bind the change event to the "actual" stop
             * @param event
             * @param ui
             */
            stop: function (event, ui) {
                jQuery('#' + inputId).trigger('change');
            }
        });
        jQuery(input).on('focus', function () {
            jQuery(this).blur();
        });
        jQuery('#' + inputId).attr('value', (jQuery('#' + id).slider('value')));
    };
    return EpsilonRangeSlider;
}());
exports.EpsilonRangeSlider = EpsilonRangeSlider;



//////////////////
// WEBPACK FOOTER
// ./assets/vendors/epsilon-framework/customizer/controls/range-slider.ts
// module id = 1
// module chunks = 0